import ApiClient from './apiClient'
import {
  Company,
  CompanyInfo,
  EditCompanyRequest,
  System,
  MailDelivery,
  RecordData,
  GoogleCallbackUrl,
  MicrosoftCallbackUrl,
  CybozuCallbackUrl,
  UrlDetailStatusRequest,
  MenuDisplay,
  getCustomAlertListResponse,
  postCustomAlertRequest,
  patchCustomAlertRequest,
  deleteCustomAlertRequest,
  patchCustomAlertForStatusRequest,
  deleteAdministratorRequest,
  getAdministratorListResponse,
  patchAdministratorRequest,
  postAdministratorRequest,
  CompanyService,
  IpRestrictionList,
  patchIpRestrictionListRequest,
  patchMfaAuthRequest,
  CompanyExternalApiKey,
  postCompanyExternalApiKeyResponse,
  postCompanyExternalApiKeyRequest,
  patchCompanyExternalApiKeyRequest,
  patchCompanyExternalApiKeyResponse,
  deleteCompanyExternalApiKeyRequest,
  companyWeeklyTrackTime,
  memberWeeklyTrackTime,
  patchMemberWeeklyTrackTimeRequest,
  deleteMemberWeeklyTrackTimeRequest,
  postMemberWeeklyTrackTimeRequest,
  postContractRequest,
  getContractRequest,
  getContractResponse,
  responseGetSettingPersonal,
  responseGetSettingCommon,
  ResponseGetSettingMeasureRestriction,
  RequestPatchSettingMeasureRestriction,
  ResponseGetSettingWebBrowser,
  RequestPatchSettingWebBrowser,
  ResponseGetSettingWeeklyTrackTime,
  RequestPatchSettingWeeklyTrackTime,
  RequestGetSettingWeeklyTrackTime,
  ResponseGetSettingRole,
  RequestGetSettingRoleDetail,
  ResponseGetSettingRoleDetail,
  ResponsePostSettingRole,
  RequestPatchSettingRole,
  ResponseGetSettingTeam,
  RequestGetSettingTeamDetail,
  ResponseGetSettingTeamDetail,
  RequestPatchSettingTeam,
  RequestPostSettingTeam,
  ResponsePostSettingTeam,
  RequestDeleteSettingTeam,
  RequestPatchSettingTeamManager,
  ResponseGetSettingBaseWorkTime,
  RequestPatchSettingBaseWorkTime,
  ResponseGetSettingHoliday,
  RequestGetSettingHoliday,
  RequestGetSettingHolidayDetail,
  ResponseGetSettingHolidayDetail,
  RequestPostSettingHoliday,
  RequestDeleteSettingRole,
  ResponseGetSettingMember,
  ResponseGetSettingCustomAlert,
  RequestPostSettingCustomAlert,
  RequestPatchSettingCustomAlert,
  RequestDeleteSettingCustomAlert,
  RequestPostSettingMember,
  RequestPatchSettingMember,
} from '../types/setting'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCompany = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/setting/company',
  (company: Company) => company,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchCompany = async (params: EditCompanyRequest): Promise<any> => ApiClient.patch(
  '/api/v1/features/setting/company',
  (company: CompanyInfo) => company,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSystem = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/setting/system',
  (system: System) => system,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSystem = async (params: RecordData): Promise<any> => ApiClient.patch(
  '/api/v1/features/setting/system',
  (system: RecordData) => system,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMailDelivery = async (): Promise<any> => ApiClient.get(
  '/api/setting/delivery',
  (mailDelivery: MailDelivery) => mailDelivery,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchMailDelivery = async (params: MailDelivery): Promise<any> => ApiClient.patch(
  '/api/setting/delivery',
  () => params,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postGoogleSync = async (): Promise<any> => ApiClient.post(
  '/api/v1/renderer/google/sync',
  (googleLoginUrl: string) => googleLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postGoogleLink = async (params: GoogleCallbackUrl): Promise<any> => ApiClient.post(
  '/api/v1/renderer/google/link',
  (result: string) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postGoogleDisassociation = async (): Promise<any> => ApiClient.post(
  '/api/v1/renderer/google',
  (googleLoginUrl: string) => googleLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMicrosoftSync = async (): Promise<any> => ApiClient.post(
  '/api/v1/renderer/microsoft/sync',
  (microsoftLoginUrl: string) => microsoftLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMicrosoftLink = async (params: MicrosoftCallbackUrl): Promise<any> => ApiClient.post(
  '/api/v1/renderer/microsoft/link',
  (result: string) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMicrosoftDisassociation = async (): Promise<any> => ApiClient.post(
  '/api/v1/renderer/microsoft',
  (microsoftLoginUrl: string) => microsoftLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postCybozuSync = async (): Promise<any> => ApiClient.get(
  '/api/setting/cybozu',
  (cybozuLoginUrl: string) => cybozuLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postCybozuLink = async (params: CybozuCallbackUrl): Promise<any> => ApiClient.post(
  '/api/setting/cybozu',
  (result: string) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postCybozuDisassociation = async (): Promise<any> => ApiClient.delete(
  '/api/setting/cybozu',
  (cybozuLoginUrl: string) => cybozuLoginUrl,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchUrlDetailStatus = async (params: UrlDetailStatusRequest): Promise<any> => ApiClient.patch(
  '/api/v1/features/setting/system/url',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMenuDisplay = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/setting/system/client_menu',
  (menuDisplay: MenuDisplay) => menuDisplay,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchMenuDisplay = async (params: MenuDisplay): Promise<any> => ApiClient.patch(
  '/api/v1/features/setting/system/client_menu',
  () => params,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomAlertList = async (): Promise<any> => ApiClient.get(
  '/api/v2/renderer/custom_alert/custom_alerts',
  (result: getCustomAlertListResponse) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postCustomAlert = async (params: postCustomAlertRequest): Promise<any> => ApiClient.post(
  '/api/v2/renderer/custom_alert/custom_alerts',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchCustomAlert = async (params: patchCustomAlertRequest): Promise<any> => ApiClient.patch(
  `/api/v2/renderer/custom_alert/custom_alerts/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchCustomAlertStatus = async (params: patchCustomAlertForStatusRequest): Promise<any> => ApiClient.patch(
  '/api/v2/renderer/custom_alert/custom_alerts/status',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteCustomAlert = async (params: deleteCustomAlertRequest): Promise<any> => ApiClient.delete(
  `/api/v2/renderer/custom_alert/custom_alerts/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAdministratorList = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/setting/administrator',
  (result: getAdministratorListResponse) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postAdministrator = async (params: postAdministratorRequest): Promise<any> => ApiClient.post(
  '/api/v1/features/setting/administrator',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchAdministrator = async (params: patchAdministratorRequest): Promise<any> => ApiClient.patch(
  `/api/v1/features/setting/administrator/${params.member_id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteAdministrator = async (params: deleteAdministratorRequest): Promise<any> => ApiClient.delete(
  `/api/v1/features/setting/administrator/${params.member_id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCompanyService = async (): Promise<any> => ApiClient.get(
  '/api/search/company_service',
  (result: CompanyService) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMfaQrCode = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/setting/mfa_auth_qrcode',
  (result: {url: string, google_secret: string}) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchMfaAuth = async (params: patchMfaAuthRequest): Promise<any> => ApiClient.patch(
  '/api/v1/features/setting/mfa_auth',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteMfaAuth = async (): Promise<any> => ApiClient.delete(
  '/api/v1/features/setting/mfa_auth',
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSlackChannelList = async (): Promise<any> => ApiClient.get(
  '/api/v1/renderer/slack/channel_list',
  (result: any) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getIpAddress = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/setting/ip_address',
  (result: string) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAllowAccess = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/setting/allow_access',
  (result: string) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getIpRestrictionList = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/setting/ip_restriction',
  (result: IpRestrictionList[]) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchIpRestrictionList = async (params: patchIpRestrictionListRequest): Promise<any> => ApiClient.patch(
  `/api/v1/features/setting/ip_restriction`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getOfficeIpList = async (): Promise<any> => ApiClient.get(
  '/api/setting/office_ip',
  (result: IpRestrictionList[]) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchOfficeIpList = async (params: patchIpRestrictionListRequest): Promise<any> => ApiClient.patch(
  `/api/setting/office_ip`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCompanyExternalApiKeyList = async (): Promise<any> => ApiClient.get(
  `/api/setting/company_external_api_keys`,
  (result: CompanyExternalApiKey[]) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postCompanyExternalApiKey = async (params: postCompanyExternalApiKeyRequest): Promise<any> => ApiClient.post(
  `/api/setting/company_external_api_keys`,
  (result: postCompanyExternalApiKeyResponse) => result,
  params,
)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchCompanyExternalApiKey = async (params: patchCompanyExternalApiKeyRequest): Promise<any> => ApiClient.patch(
  `/api/setting/company_external_api_keys/${params.id}`,
  (result: patchCompanyExternalApiKeyResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteCompanyExternalApiKey = async (params: deleteCompanyExternalApiKeyRequest): Promise<any> => ApiClient.delete(
  `/api/setting/company_external_api_keys/${params.id}`,
  () => { /* */ },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCompanyWeeklyTrackTime = async (): Promise<any> => ApiClient.get(
  `/api/setting/company_weekly_track_time`,
  (result: companyWeeklyTrackTime) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchCompanyWeeklyTrackTime = async (params: companyWeeklyTrackTime): Promise<any> => ApiClient.patch(
  `/api/setting/company_weekly_track_time`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMemberWeeklyTrackTime = async (params: { only_oneself: boolean }): Promise<any> => ApiClient.get(
  `/api/setting/weekly_track_time`,
  (result: memberWeeklyTrackTime) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMemberWeeklyTrackTime = async (params: postMemberWeeklyTrackTimeRequest): Promise<any> => ApiClient.post(
  `/api/setting/weekly_track_time`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchMemberWeeklyTrackTime = async (params: patchMemberWeeklyTrackTimeRequest): Promise<any> => ApiClient.patch(
  `/api/setting/weekly_track_time`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteMemberWeeklyTrackTime = async (params: deleteMemberWeeklyTrackTimeRequest): Promise<any> => ApiClient.delete(
  `/api/setting/weekly_track_time`,
  () => {
    // do nothing
  },
  { data: params },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getContract = async (params: getContractRequest): Promise<any> => ApiClient.get(
  '/api/setting/contract',
  (result: getContractResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postContract = async (params: postContractRequest): Promise<any> => ApiClient.post(
  '/api/setting/contract',
  (result: string) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingPersonal = async (): Promise<any> => ApiClient.get(
  '/api/setting/personal',
  (result: responseGetSettingPersonal) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingCommon = async (): Promise<any> => ApiClient.get(
  '/api/setting/common',
  (result: responseGetSettingCommon) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingMeasureRestriction = async (): Promise<any> => ApiClient.get(
  '/api/setting/measure_restriction',
  (result: ResponseGetSettingMeasureRestriction) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingMeasureRestriction = async (params: RequestPatchSettingMeasureRestriction): Promise<any> => ApiClient.patch(
  '/api/setting/measure_restriction',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingWebBrowser = async (): Promise<any> => ApiClient.get(
  '/api/setting/web_browser',
  (result: ResponseGetSettingWebBrowser) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingWebBrowser = async (params: RequestPatchSettingWebBrowser): Promise<any> => ApiClient.patch(
  '/api/setting/web_browser',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingWeeklyTrackTime = async (params: RequestGetSettingWeeklyTrackTime): Promise<any> => ApiClient.get(
  '/api/setting/weekly_track_time',
  (result: ResponseGetSettingWeeklyTrackTime) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingWeeklyTrackTime = async (params: RequestPatchSettingWeeklyTrackTime): Promise<any> => ApiClient.patch(
  '/api/setting/weekly_track_time',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingRole = async (): Promise<any> => ApiClient.get(
  '/api/setting/roles',
  (result: ResponseGetSettingRole) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingRoleDetail = async (params: RequestGetSettingRoleDetail): Promise<any> => ApiClient.get(
  `/api/setting/roles/${params.id}`,
  (result: ResponseGetSettingRoleDetail) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postSettingRole = async (): Promise<any> => ApiClient.post(
  '/api/setting/roles',
  (result: ResponsePostSettingRole) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingRole = async (params: RequestPatchSettingRole): Promise<any> => ApiClient.patch(
  `/api/setting/roles/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteSettingRole = async (params: RequestDeleteSettingRole): Promise<any> => ApiClient.delete(
  `/api/setting/roles/${params.id}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingTeam = async (): Promise<any> => ApiClient.get(
  '/api/setting/teams',
  (result: ResponseGetSettingTeam) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingTeamDetail = async (params: RequestGetSettingTeamDetail): Promise<any> => ApiClient.get(
  `/api/setting/teams/${params.id}`,
  (result: ResponseGetSettingTeamDetail) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postSettingTeam = async (params: RequestPostSettingTeam): Promise<any> => ApiClient.post(
  `/api/setting/teams/`,
  (result: ResponsePostSettingTeam) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingTeam = async (params: RequestPatchSettingTeam): Promise<any> => ApiClient.patch(
  `/api/setting/teams/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteSettingTeam = async (params: RequestDeleteSettingTeam): Promise<any> => ApiClient.delete(
  `/api/setting/teams/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingTeamManager = async (params: RequestPatchSettingTeamManager): Promise<any> => ApiClient.patch(
  `/api/setting/teams/${params.team_id}/managers/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingMember = async (): Promise<any> => ApiClient.get(
  '/api/setting/members',
  (result: ResponseGetSettingMember) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postSettingMember = async (params: RequestPostSettingMember): Promise<any> => ApiClient.post(
  '/api/setting/members',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingMember = async (memberId: number, params: RequestPatchSettingMember): Promise<any> => ApiClient.patch(
  `/api/setting/members/${memberId}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteSettingMember = async (memberId: number): Promise<any> => ApiClient.delete(
  `/api/setting/members/${memberId}`,
  (result: Record<string, unknown>) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingBaseWorkTime = async (): Promise<any> => ApiClient.get(
  '/api/setting/base_work_time',
  (result: ResponseGetSettingBaseWorkTime) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingBaseWorkTime = async (params: RequestPatchSettingBaseWorkTime): Promise<any> => ApiClient.patch(
  '/api/setting/base_work_time',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingHoliday = async (params: RequestGetSettingHoliday): Promise<any> => ApiClient.get(
  '/api/setting/holidays',
  (result: ResponseGetSettingHoliday) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingHolidayDetail = async (params: RequestGetSettingHolidayDetail): Promise<any> => ApiClient.get(
  `/api/setting/holidays/${params.id}`,
  (result: ResponseGetSettingHolidayDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postSettingHoliday = async (params: RequestPostSettingHoliday): Promise<any> => ApiClient.post(
  `/api/setting/holidays`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSettingCustomAlert = async (): Promise<any> => ApiClient.get(
  '/api/setting/custom_alerts',
  (result: ResponseGetSettingCustomAlert) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postSettingCustomAlert = async (params: RequestPostSettingCustomAlert): Promise<any> => ApiClient.post(
  '/api/setting/custom_alerts',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSettingCustomAlert = async (params: RequestPatchSettingCustomAlert): Promise<any> => ApiClient.patch(
  `/api/setting/custom_alerts/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteSettingCustomAlert = async (params: RequestDeleteSettingCustomAlert): Promise<any> => ApiClient.delete(
  `/api/setting/custom_alerts/${params.id}`,
  () => {
    // do nothing
  },
  params,
)
